<section
  class="grid
    xxs:grid-cols-2 xs:grid-cols-2 sm:grid-cols-4 md:grid-cols-4 md2:grid-cols-10 lg:grid-cols-10 xl:grid-cols-10
    xxs:gap-4 xs:gap-4 sm:gap-5 md:gap-5 md2:gap-16 lg:gap-20 xl:gap-24
    xxs:max-w-[70vw] xs:max-w-[65vw] sm:max-w-[55vw] md:max-w-[55vw]
    xxs:mx-auto xs:mx-auto sm:mx-auto md:mx-auto md2:mx-[48px] lg:mx-40 xl:mx-44"
>
  <slot />
</section>
